<style scoped> 
    .label {
        font-weight: 600;
    }
    .custom-checkbox{
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        width: 24px;
        height: 24px;
        border: 2px solid #9e9e9e;
        border-radius: 4px;
        background-color: white;
        position: relative;
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .custom-checkbox:checked{
        background-color: white;
        border-color: #4467f2;
    }

    .custom-checkbox:checked::before{
        content: "✔";
        columns: white;
        font-size: 16px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .custom-checkbox:hover{
        border-color: #757575;
    }

    .label-check{
        margin-left: 8px;
        font-size: 16px;
        columns: #333;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
    }
</style>
<template>
    <div class="col-md-6 col-sm-12">
        <div class="card-header p-primary bg-transparent">
            <h5 class="card-title m-0 label">{{ $t('checklist') }}</h5>
        </div>
        <div class="form-group row mb-0 mt-2">
            <div class="custom-control w-100" v-for="item in list" :key="item.id">
                <input 
                    class="custom-checkbox"
                    type="checkbox" 
                    :id="item.id"
                    :value="item.value"
                    v-model="selectedCheckList" 
                    :disabled="read"
                />
                <label class="label-check" :for="item.id">{{ item.value }}</label>
            </div>
        </div>
    </div>
</template>
  
<script>
    export default {
        name: 'CheckList',
        props: {
            value: {
                type: Array,
                default: null
            },
            list: {
                type: Array,
                required: true
            },
            read : {
                type : Boolean,
                default : false
            }
        },
        computed: {
            selectedCheckList: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>